<template>

  <div class="game-board">
    <div class="box">
      <router-link to="/risk">
      <img :src="require('@/assets/framework/1-risk.png')" alt="Risk Management"></router-link>
      <span></span>
    </div>
    <div class="box"><router-link to="/insurance">
      <img :src="require('@/assets/framework/2-insure.png')" alt="Negotiating"></router-link>
      <span></span>
    </div>    
    <div class="box"><router-link to="/save">
      <img :src="require('@/assets/framework/3-save.png')" alt="Goal Setting"></router-link>
      <span></span>
    </div>    
    <div class="box"><router-link to="/kyc">
      <img :src="require('@/assets/framework/4-kyc.png')" alt="Yield Optimizing"></router-link>
      <span></span>
    </div>    
    <div class="box"><router-link to="/yield">
      <img :src="require('@/assets/framework/5-yield.png')" alt="Credit"></router-link>
      <span></span>
    </div>    
    <div class="box"><router-link to="/planning">
      <img :src="require('@/assets/framework/6-planning.png')" alt="Asset Allocation"></router-link>
      <span></span>
    </div>
      <div class="box"><router-link to="/assets">
      <img :src="require('@/assets/framework/7-assets.png')" alt="Trading"></router-link>
      <span></span>
      </div>
    <div class="box"><router-link to="/wealth">
      <img :src="require('@/assets/framework/8-wealthmanagement.png')" alt="Save">
    </router-link>
      <span></span>
    </div>
    <div class="box"><router-link to="/strategies">
      <img :src="require('@/assets/framework/9-strategies.png')" alt="Strategies"></router-link>
      <span></span>
    </div>
  
    </div>    
  
<br><br><br><br><br><br>
</template>

<script>



</script>

<style scoped>
/* Default style (Mobile First) */
.game-board {
  display: grid;
  grid-template-rows: 185px 185px 185px;
  grid-template-columns: 125px 125px 125px;
  color: white
}

body {
  display: flex;
  justify-content: center;
}

.box img:hover {
  transform: scale(1.25);  /* Enlarge the image to 120% */
  transition: transform 0.3s ease-in-out;  /* Animation */
}

.box {
  background: white;
  border: 1px solid;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #AAA;
}

img {
  max-width: 135px;  /* You can adjust the size */
  max-height: 150px; /* You can adjust the size */
}

/* Larger Screens */
@media (min-width: 768px) {
  .game-board {
    grid-template-rows: repeat(3, 33vh);
    grid-template-columns: repeat(3, 33vw);
  }

  img {
    max-width: 30vw;
    max-height: 30vh;
  }
  .title {
  background-color: #4A148C; /* Deep purple background */
  color: #FFFFFF; /* White text color */
  font-family: 'Helvetica Neue', sans-serif; /* Modern font */
  text-align: center; /* Center the title */
  padding: 10px 0; /* Padding above and below text */
  margin: 10px 0; /* Space above and below the div */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  border-radius: 10px; /* Rounded corners */
  transition: transform 0.3s ease; /* Smooth transform on hover */
}

.title:hover {
  transform: translateY(-5px); /* Slight lift effect on hover */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2); /* Deeper shadow for lifting effect */
}

/* Responsive font size */
  

  .box img:hover {
  transform: scale(1.3);  /* Enlarge the image to 120% */
  transition: transform 0.3s ease-in-out;  /* Animation */
}
}

.title {
  background-color: #4A148C;
  color: #FFFFFF;
  font-family: 'Helvetica Neue', sans-serif;
  text-align: center;
  padding: 20px 0;
  margin: 20px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 2px solid #C9B6D9; /* Light purple border */
  transition: transform 0.3s ease;
}

.title:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.game-board {
  display: grid;
  grid-template-rows: 185px 185px 185px;
  grid-template-columns: 125px 125px 125px;
  color: white;
  border: 2px solid #C9B6D9; /* Light purple border */
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 20px; /* Space below the game board */
  width: 100%; 
  margin: 0 auto; 
}

.box img:hover {
  transform: scale(1.25);
  transition: transform 0.3s ease-in-out;
}

.box {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #AAA;
}

img {
  max-width: 135px;
  max-height: 150px;
}


@media (min-width: 768px) {
  .game-board {
    grid-template-rows: repeat(3, 33vh);
    grid-template-columns: repeat(3, 33vw);
  }

  img {
    max-width: 27vw;
    max-height: 25vh;
  }

  .box img:hover {
    transform: scale(1.3);
  }
}


</style>
